import React from "react";
import { Stack, Box, Typography } from "@mui/material";

/**
 * Mini stat cards reutilizables — row de mini-badges.
 * Usado por Panels 2, 3, 4, 5, 7.
 *
 * @param {{ items: Array<{ label, value, color, bgColor, icon? }> }} props
 */
export default function CMStatCards({ items }) {
  return (
    <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", gap: 1 }}>
      {items.map((item) => (
        <Box
          key={item.label}
          sx={{
            flex: 1,
            minWidth: 100,
            p: 1,
            borderRadius: 1.5,
            bgcolor: item.bgColor,
            textAlign: "center",
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5}>
            {item.icon && (
              <Box sx={{ color: item.color, display: "flex", alignItems: "center" }}>
                {item.icon}
              </Box>
            )}
            <Typography variant="h6" fontWeight={800} sx={{ color: item.color, lineHeight: 1.1 }}>
              {item.value?.toLocaleString() ?? 0}
            </Typography>
          </Stack>
          <Typography variant="caption" sx={{ fontSize: "0.6rem", color: item.color, fontWeight: 600 }}>
            {item.label}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}
